import React, { useState, useEffect, Fragment } from 'react';
import { Grid } from '@material-ui/core';
import styles from './WorkflowSection.module.scss';
import DefaultContainer from '../DefaultContainer';
import HeadlineSmall from '../HeadlineSmall';
import HeadlineLarge from '../HeadlineLarge';
import { wearePage } from '../../data';
import Icon from '../Icon';

const items = [
  {
    icon: 'weAppIdea',
    title: wearePage.workflowStep1Title,
    text: wearePage.workflowStep1Text,
  },
  {
    icon: 'weAppResearch',
    title: wearePage.workflowStep2Title,
    text: wearePage.workflowStep2Text,
  },
  {
    icon: 'weAppDevelopment',
    title: wearePage.workflowStep3Title,
    text: wearePage.workflowStep3Text,
  },
  {
    icon: 'weAppData',
    title: wearePage.workflowStep4Title,
    text: wearePage.workflowStep4Text,
  },
];

const WorkflowSection = () => {
  const [isMobile, setIsMobile] = useState(false);

  const resize = () => {
    if (window !== 'undefined') {
      setIsMobile(window.innerWidth < 799);
    }
  };

  useEffect(() => {
    if (window) {
      window.addEventListener('resize', resize);
      setIsMobile(window.innerWidth < 799);
    }
    return () => {
      window.removeEventListener('resize', resize);
    };
  }, []);

  const renderMobileWorkflow = () => (
    items.map(({ icon, title, text }, index) => (
      <div className={styles.containerStep} key={title}>
        <Grid container justify="center" alignItems="center">
          <Grid item xs>
            <div
              className={[
                styles.separatorWorkflow,
                index === 0 && styles.noBorder,
                styles.separatorLeft,
              ].join(' ')}
            />
          </Grid>
          <Grid item xs="auto" className={styles.containerIconMobile}>
            <Icon type={icon} />
          </Grid>
          <Grid item xs>
            <div
              className={[
                styles.separatorWorkflow,
                index === 3 && styles.noBorder,
                styles.separatorRight,
              ].join(' ')}
            />
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <h4 className={styles.textDefaultLarge}>{title}</h4>
          <p className={styles.textDefaultSmall}>{text}</p>
        </Grid>
      </div>
    ))
  );

  const renderDesktopWorkflow = () => (
    <Fragment>
      <Grid container className={styles.containerTextInfoFirst}>
        {
          [items[0], items[2]].map(({ title, text }) => (
            <Fragment key={title}>
              <Grid item xs={3}>
                <h4 className={styles.textDefaultLarge}>{title}</h4>
                <p className={styles.textDefaultSmall}>{text}</p>
              </Grid>
              <Grid item xs />
            </Fragment>
          ))
        }
      </Grid>
      <Grid container alignItems="center" className={styles.containerIcons}>
        <Grid item xs />
        <Grid item xs={1}>
          <Icon type="weAppIdea" />
        </Grid>
        <Grid item xs={2}>
          <div className={styles.separatorWorkflow} />
        </Grid>
        <Grid item xs={1}>
          <Icon type="weAppDevelopment" />
        </Grid>
        <Grid item xs={2}>
          <div className={styles.separatorWorkflow} />
        </Grid>
        <Grid item xs={1}>
          <Icon type="weAppResearch" />
        </Grid>
        <Grid item xs={2}>
          <div className={styles.separatorWorkflow} />
        </Grid>
        <Grid item xs={1}>
          <Icon type="weAppData" />
        </Grid>
        <Grid item xs />
      </Grid>
      <Grid container>
        {
          [items[1], items[3]].map(({ title, text }) => (
            <Fragment key={title}>
              <Grid item xs />
              <Grid item xs={3}>
                <h4 className={styles.textDefaultLarge}>{title}</h4>
                <p className={styles.textDefaultSmall}>{text}</p>
              </Grid>
            </Fragment>
          ))
        }
      </Grid>
    </Fragment>
  );


  return (
    <div className={styles.container}>
      <DefaultContainer justify="flex-start">
        <Grid item>
          <HeadlineSmall>{wearePage.workflowHeadlineSmall}</HeadlineSmall>
          <HeadlineLarge
            stroke={wearePage.workflowHeadlineLargeStroke}
            lineBreak
            className={styles.headlineLarge}
            medium
          >
            {wearePage.workflowHeadlineLarge}
          </HeadlineLarge>
        </Grid>
        { !isMobile && renderDesktopWorkflow() }
      </DefaultContainer>
      { isMobile && renderMobileWorkflow() }
    </div>
  );
};

export default WorkflowSection;
